import React from 'react';

import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';

import { PropTypes } from 'prop-types';


export default class FormSwitch extends React.Component {
    //TODO: Override styling to ensure labeled switch matches height of labeled dropdowns / text fields.
    //      Note that the child "ripple" element appears to hold a height that is too large.  Need to
    //      override that child Material element using a theme.
    render() {
        return (
            <FormGroup>
                <InputLabel shrink>{this.props.label}</InputLabel>
                <Switch
                    name={this.props.name}
                    checked={this.props.checked}
                    onChange={this.props.onChange}
                    color={this.props.color}
                    size={this.props.size}
                    key={this.props.key}
                />
            </FormGroup>
        );
    }
}

FormSwitch.propTypes = {
    checked: PropTypes.bool,
    color: PropTypes.string,
    key: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    size: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/FormSwitch.js